import { Injectable } from '@angular/core';

@Injectable()
export class ProgressConfig {
  color = 'primary';
  thickness = 1;
}
